import React from 'react';
import PropType from 'prop-types';
import getActivityInfo from '../../utils/activityHelpers/getActivityInfo';
import WorkoutOwnerHeading from './WorkoutOwnerHeading';
import Images from './Images';
import { formatDistance } from '../../utils/unitAndFormatHelpers/formatters';
import { getSuffix } from '../../utils/unitAndFormatHelpers/formatterUtils';

export default function SimpleWorkoutItem({ workout, t }) {
  const activityInfo = getActivityInfo(workout.activityId);
  return (
    <div className="card is-relative simple-workout-item has-overflow-hidden">
      <div className="columns is-gapless is-marginless is-multiline">
        <div className="column is-12">
          <WorkoutOwnerHeading workout={workout} when={t('FROM_NOW', { time: workout.startTime })} icon={activityInfo && activityInfo.Icons ? activityInfo.Icons[0] : null} />
        </div>
        <div className="column is-12">
          {workout.photos.length > 0 && <Images images={workout.photos} hasNoControls isCroppedNotStretched />}
        </div>
        <div className="column is-12">
          {workout.totalDistance !== 0
          && (
          <h2 className="is-absolute is-fullwidth title is-data-field is-number has-text-white">
            {formatDistance(workout.totalDistance, 'metric', 'Threedigits')}
            {' '}
            <span className="suffix">{getSuffix('Distance', 'metric', 'Threedigits', t, workout.totalDistance)}</span>
          </h2>
          )}
        </div>
      </div>
    </div>
  );
}
SimpleWorkoutItem.propTypes = {
  workout: PropType.object.isRequired,
  t: PropType.func.isRequired,
};
